import { render, staticRenderFns } from "./SkillsCompetitionsList.vue?vue&type=template&id=08a0c615&scoped=true&"
import script from "./SkillsCompetitionsList.vue?vue&type=script&lang=js&"
export * from "./SkillsCompetitionsList.vue?vue&type=script&lang=js&"
import style0 from "./SkillsCompetitionsList.vue?vue&type=style&index=0&id=08a0c615&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a0c615",
  null
  
)

export default component.exports